
























import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Icon } from '~/models/icons/types'
import { ciPlus } from '~/icons/source/regular/plus'

export default defineComponent({
  props: {
    icon: {
      type: Object as PropType<Icon>,
      default: ciPlus
    },
    to: {
      type: [String, Object],
      required: false,
      default: undefined
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    newButtonText: {
      type: String,
      default: ''
    }
  },
  setup() {
    return { ciPlus }
  }
})
